const coerceMessage = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  if (Array.isArray(value)) {
    const parts = value
      .map((item) => (typeof item === 'string' ? item.trim() : coerceMessage(item)))
      .filter(Boolean);
    return parts.length ? parts.join(' ') : null;
  }
  if (typeof value === 'object') {
    const entries = Object.values(value);
    for (const entry of entries) {
      const result = coerceMessage(entry);
      if (result) {
        return result;
      }
    }
    return null;
  }
  if (typeof value === 'string') {
    const text = value.trim();
    return text.length ? text : null;
  }
  return String(value);
};

export const extractApiError = (error, fallback = 'Request failed. Please try again.') => {
  const responseData = error?.response?.data;
  const responseStatusText = error?.response?.statusText;

  const priorityKeys = [
    'detail',
    'message',
    'error',
    'non_field_errors',
    'tags',
    'slug',
    'name',
    'category'
  ];

  if (responseData) {
    if (typeof responseData === 'string' || Array.isArray(responseData)) {
      const direct = coerceMessage(responseData);
      if (direct) {
        return direct;
      }
    }

    if (typeof responseData === 'object') {
      for (const key of priorityKeys) {
        if (key in responseData) {
          const result = coerceMessage(responseData[key]);
          if (result) {
            return result;
          }
        }
      }
      const nested = coerceMessage(responseData);
      if (nested) {
        return nested;
      }
    }
  }

  if (responseStatusText) {
    const statusText = responseStatusText.trim();
    if (statusText) {
      return statusText;
    }
  }

  if (error?.message) {
    const messageText = String(error.message).trim();
    if (messageText) {
      return messageText;
    }
  }

  return fallback;
};

export default extractApiError;
